// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Switcher-module--bx--text-truncate--end--2nId8";
export var bxTextTruncateFront = "Switcher-module--bx--text-truncate--front--17FYS";
export var divider = "Switcher-module--divider--3RiYI";
export var link = "Switcher-module--link--36NYi";
export var linkDisabled = "Switcher-module--link--disabled--3l8dk";
export var nav = "Switcher-module--nav--3zMR9";
export var open = "Switcher-module--open--3fjUz";